import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import HeaderTitle from "../components/HeaderTitle";
import cww from "../assets/dashboard/cww.png";
import ha from "../assets/dashboard/ha.png";
import iraRecieved from "../assets/dashboard/ira-recieved.png";
import nrt from "../assets/dashboard/nrt.png";
import tnva from "../assets/dashboard/tnva.png";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  PieSeries,
  AccumulationDataLabel,
  Tooltip,
  DataLabel,
  SeriesDirective,
  SeriesCollectionDirective,
  ChartComponent,
  ColumnSeries,
  Highlight,
  Legend,
  Category,
  BarSeries,
} from "@syncfusion/ej2-react-charts";
import DisasterMgtService from "../service/citizen/DisasterMgtService";
import infoIcon from "../assets/dashboard/info-icon.png";
import HouseholdsAffectedModal from "../components/HouseholdsAffectedModal";
import {
  Chart3DComponent,
  Chart3DSeriesCollectionDirective,
  Chart3DSeriesDirective,
  BarSeries3D,
  Legend3D,
  Tooltip3D,
  Category3D,
  Highlight3D,
  ColumnSeries3D,
  CircularChart3DComponent,
  CircularChart3DSeriesCollectionDirective,
  CircularChart3DSeriesDirective,
  PieSeries3D,
  CircularChartDataLabel3D,
  CircularChartTooltip3D,
  CircularChartLegend3D,
} from "@syncfusion/ej2-react-charts";
import { Browser } from "@syncfusion/ej2-base";
import { format } from "prettier";

// 3D Graphs

const BarChartHorizontal = ({
  data,
  title,
  palettes,
  legends,
  subTitle,
  maximum,
}) => {
  return (
    <div className="flex flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
      <p className="font-bold">
        {title} {subTitle || ""}
      </p>
      <div className="h-full w-full">
        <Chart3DComponent
          id={title}
          // rotation={20}
          // tilt={0}
          depth={100}
          // enableRotation={true}
          style={{ textAlign: "center" }}
          primaryXAxis={{
            valueType: "Category",
            interval: 1,
            majorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            minorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            labelPosition: "Outside",
          }}
          primaryYAxis={{
            minimum: 0,
            maximum:
              maximum ||
              data.reduce(
                (acc, c, i, arr) =>
                  (acc +=
                    ([...(arr || [])]?.sort((a, b) => b.y - a.y)?.[0].y || 0) *
                    0.3),
                0
              ),
            labelFormat: "{value}",
            interval: 2,
            majorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            opposedPosition: true,
          }}
          chartArea={{ border: { width: 0 } }}
          titleStyle={{ position: "Bottom" }}
          legendSettings={{ visible: false }}
          tooltip={{
            enable: true,
            header: "<b>${point.x}</b>",
          }}
          height="500px"
        >
          <Inject
            services={[
              BarSeries3D,
              Category3D,
              Tooltip3D,
              Legend3D,
              Highlight3D,
            ]}
          />
          <Chart3DSeriesCollectionDirective>
            <Chart3DSeriesDirective
              xName="x"
              yName="y"
              columnSpacing={0.2}
              dataSource={data}
              fill={palettes}
              type="Bar"
              cornerRadius={{
                bottomLeft: 5,
                bottomRight: 5,
                topLeft: 5,
                topRight: 5,
              }}
            />
          </Chart3DSeriesCollectionDirective>
        </Chart3DComponent>
      </div>
    </div>
  );
};

const BarChart = ({ data = [], title, palettes = [], legends, subTitle }) => {
  const safeData = data
    .map((d) => ({
      ...d,
      y: typeof d.y === "string" ? parseFloat(d.y) : d.y,
    }))
    .filter((d) => typeof d.y === "number" && !isNaN(d.y));

  const yMax =
    safeData.length > 0
      ? Math.ceil(Math.max(...safeData.map((d) => d.y)) * 1.2)
      : 10;

  const handlePointRender = (args) => {
    if (palettes?.length > 0) {
      args.fill = palettes[args.point.index % palettes.length];
    }
  };

  return (
    <div className="flex h-[385px] flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
      <p className="font-bold">
        {title} {subTitle || ""}
      </p>
      <div className="flex h-[335px] w-full">
        <div className="relative flex h-full w-[80%] items-center justify-center">
          <Chart3DComponent
            id={title}
            style={{ height: "100%", minHeight: "300px", width: "100%" }}
            // title={title}
            // enableRotation={true}
            rotation={7}
            // tilt={10}
            depth={100}
            tooltip={{
              enable: true,
              header: "${point.x}",
              format: "Value: <b>${point.y}</b>",
            }}
            primaryXAxis={{
              valueType: "Category",
              labelPlacement: "BetweenTicks",
              labelRotation: -45,
              interval: 1,
              labelStyle: { size: "0px" },
            }}
            primaryYAxis={{
              minimum: 0,
              maximum: yMax,
              interval: Math.ceil(yMax / 5),
            }}
            legendSettings={{ visible: false }}
            wallColor="transparent"
            pointRender={handlePointRender}
          >
            <Inject
              services={[
                ColumnSeries3D,
                Category3D,
                Tooltip3D,
                Legend3D,
                Highlight3D,
              ]}
            />
            <Chart3DSeriesCollectionDirective>
              <Chart3DSeriesDirective
                dataSource={safeData}
                xName="x"
                yName="y"
                columnSpacing={0.1}
                type="Column"
              />
            </Chart3DSeriesCollectionDirective>
          </Chart3DComponent>
        </div>
        {legends && (
          <div className=" flex-1 flex-col items-center justify-center space-y-2 overflow-y-auto ">
            {legends.map((label, i) => (
              <div
                key={i}
                className="flex w-full items-center justify-center space-x-2"
              >
                <div
                  className="h-[14px] w-[14px] rounded-full"
                  style={{ backgroundColor: palettes[i] }}
                />
                <div className="w-[80%]">
                  <p className="text-wrap text-[14px]">{label}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const PieChart = ({ title, data, palettes, legend }) => {
  return (
    <div className="flex h-[385px] flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
      <p className="font-bold">{title}</p>
      <div className="flex h-full w-full">
        <div className="relative flex h-full w-[70%] items-center justify-center">
          <CircularChart3DComponent
            id={title}
            tilt={-45}
            // enableRotation={true}
            legendSettings={{ visible: false }}
            tooltip={{
              enable: true,
            }}
          >
            <Inject
              services={[
                PieSeries3D,
                CircularChartDataLabel3D,
                CircularChartTooltip3D,
                CircularChartLegend3D,
              ]}
            />
            <CircularChart3DSeriesCollectionDirective>
              <CircularChart3DSeriesDirective
                dataSource={data}
                xName="x"
                yName="y"
                explode={true}
                radius={Browser.isDevice ? "45%" : "75%"}
                innerRadius="0%"
                dataLabel={{
                  visible: true,
                  position: "Outside",
                  name: "y",
                  font: {
                    fontWeight: "bold",
                    size: "18px",
                  },
                  connectorStyle: {
                    length: "40px",
                    type: "Line",
                  },
                }}
                palettes={palettes}
              />
            </CircularChart3DSeriesCollectionDirective>
          </CircularChart3DComponent>
        </div>
        {legend && (
          <div className="flex h-full flex-1 flex-col items-center justify-center space-y-2">
            {legend.map((label, i) => (
              <div
                key={i}
                className="flex w-full items-center justify-center space-x-2"
              >
                <div
                  className="h-[14px] w-[14px] rounded-full"
                  style={{ backgroundColor: palettes[i] }}
                />
                <div className="w-[80%]">
                  <p className="text-wrap text-[14px]">{label}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// NOT 3D

// const BarChartHorizontal = ({
//   data,
//   title,
//   palettes,
//   legends,
//   subTitle,
//   maximum,
// }) => {
//   return (
//     <div className="flex flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
//       <p className="font-bold">
//         {title} {subTitle || ""}
//       </p>
//       <div className="h-full w-full">
//         <ChartComponent
//           id={title}
//           style={{ textAlign: "center" }}
//           primaryXAxis={{
//             valueType: "Category",
//             interval: 1,
//             majorGridLines: { width: 0 },
//             majorTickLines: { width: 0 },
//             minorTickLines: { width: 0 },
//             lineStyle: { width: 0 },
//             labelPosition: "Outside",
//           }}
//           primaryYAxis={{
//             minimum: 0,
//             maximum:
//               maximum ||
//               data.reduce(
//                 (acc, c, i, arr) =>
//                   (acc +=
//                     ([...(arr || [])]?.sort((a, b) => b.y - a.y)?.[0].y || 0) *
//                     0.3),
//                 0
//               ),
//             labelFormat: "{value}",
//             interval: 2,
//             majorGridLines: { width: 0 },
//             majorTickLines: { width: 0 },
//             lineStyle: { width: 0 },
//             opposedPosition: true,
//           }}
//           chartArea={{ border: { width: 0 } }}
//           titleStyle={{ position: "Bottom" }}
//           legendSettings={{ visible: false }}
//           tooltip={{
//             enable: true,
//             header: "<b>${point.x}</b>",
//           }}
//           height="500px"
//         >
//           <Inject services={[BarSeries, DataLabel, Category, Tooltip]} />
//           <SeriesCollectionDirective>
//             <SeriesDirective
//               xName="x"
//               yName="y"
//               columnWidth={0.5}
//               dataSource={data}
//               dataLabel="Test"
//               fill={palettes}
//               type="Bar"
//               cornerRadius={{
//                 bottomLeft: 5,
//                 bottomRight: 5,
//                 topLeft: 5,
//                 topRight: 5,
//               }}
//             />
//           </SeriesCollectionDirective>
//         </ChartComponent>
//       </div>
//     </div>
//   );
// };

// const BarChart = ({ data, title, palettes, legends, subTitle }) => {
//   return (
//     <div className="flex h-[312px] flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
//       <p className="font-bold">
//         {title} {subTitle || ""}
//       </p>
//       <div className="h-full w-full">
//         <ChartComponent
//           style={{ height: "100%", width: "100%" }}
//           primaryXAxis={{
//             valueType: "Category",
//             majorGridLines: { width: 0 },
//             labelStyle: { size: "11px" },
//           }}
//           primaryYAxis={{
//             minimum: 0,
//             maximum: data.reduce(
//               (acc, c, i, arr) =>
//                 (acc +=
//                   ([...(arr || [])]?.sort((a, b) => b.y - a.y)?.[0].y || 0) *
//                   0.3),
//               0
//             ),
//             interval: 2,
//             majorTickLines: { width: 0 },
//             labelFormat: "{value}",
//             lineStyle: { width: 0 },
//             labelStyle: { size: "11px" },
//             titleStyle: { size: "13px" },
//           }}
//           chartArea={{ border: { width: 0 }, margin: { bottom: 12 } }}
//         >
//           <Inject
//             services={[
//               ColumnSeries,
//               Legend,
//               Tooltip,
//               Category,
//               DataLabel,
//               Highlight,
//             ]}
//           ></Inject>
//           <SeriesCollectionDirective>
//             <SeriesDirective
//               type="Column"
//               dataSource={data.map(({ x, y }, i) => ({
//                 Period: legends?.[i] || x,
//                 Percentage: y,
//               }))}
//               xName="Period"
//               yName="Percentage"
//               fill={palettes}
//               marker={{
//                 dataLabel: {
//                   visible: true,
//                   position: "Top",
//                   font: { color: "white" },
//                 },
//               }}
//               cornerRadius={{ topLeft: 4, topRight: 4 }}
//             ></SeriesDirective>
//           </SeriesCollectionDirective>
//         </ChartComponent>
//       </div>
//     </div>
//   );
// };

// const PieChart = ({ title, data, palettes, legend }) => {
//   return (
//     <div className="flex h-[385px] flex-col space-y-2 border border-solid border-[#CFCFCF] p-[8px]">
//       <p className="font-bold">{title}</p>
//       <div className="flex h-full w-full">
//         <div className="relative flex h-full w-[70%] items-center justify-center">
//           <AccumulationChartComponent id={title}>
//             <Inject services={[PieSeries, AccumulationDataLabel]} />
//             <AccumulationSeriesCollectionDirective>
//               <AccumulationSeriesDirective
//                 dataSource={data}
//                 xName="x"
//                 yName="y"
//                 startAngle={60}
//                 dataLabel={{
//                   visible: true,
//                   position: "Outside",
//                   connectorStyle: { length: "20px", type: "Line" },
//                   name: "text",
//                   font: { fontWeight: "800", size: "18px" },
//                 }}
//                 palettes={palettes}
//               />
//             </AccumulationSeriesCollectionDirective>
//           </AccumulationChartComponent>
//         </div>
//         <div className="flex h-full flex-1 flex-col items-center justify-center space-y-2">
//           {legend.map((label, i) => (
//             <div
//               key={i}
//               className="flex w-full items-center justify-center space-x-2"
//             >
//               <div
//                 className="h-[14px] w-[14px] rounded-full"
//                 style={{ backgroundColor: palettes[i] }}
//               />
//               <div className="w-[80%]">
//                 <p className="text-wrap text-[14px]">{label}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

const KPI = ({
  totalHouseholdAffected,
  householdMembersCount,
  totalRecords,
  vehiclesAffected,
  transportationCount,
  wellWaterCount,
  affectedHouseholds,
}) => {
  const [showHouseholdsModal, setShowHouseholdsModal] = useState(false);

  const formatNumber = (number) => {
    return number.toLocaleString();
  };

  let totalHouseholdAffectedData = formatNumber(totalHouseholdAffected || 0);
  let totalRecordsData = formatNumber(
    (totalRecords || 0) + (householdMembersCount || 0)
  );
  let vehiclesAffectedData = formatNumber(vehiclesAffected || 0);
  let transportationCountData = formatNumber(transportationCount?.no || 0);
  let wellWaterCountData = formatNumber(wellWaterCount?.yes || 0);

  return (
    <div className="flex space-x-2">
      <div className="flex-1 space-y-2">
        <div className="flex items-center space-x-4 border border-solid border-[#CFCFCF] p-[16px]">
          <div className="h-[44px] w-[44px] rounded-md bg-[#003460] p-[8px]">
            <img className="h-full w-full object-contain" src={ha} />
          </div>
          <div className="flex flex-1 flex-col">
            <p className="text-sm">Households Affected</p>
            <p className="text-[24px] font-bold">
              {totalHouseholdAffectedData}
            </p>
          </div>
          <button
            className="h-[32px] w-[32px] cursor-pointer bg-transparent"
            onClick={() => setShowHouseholdsModal(true)}
          >
            <img src={infoIcon} className="h-full w-full object-contain" />
          </button>
        </div>
        <div className="flex items-center space-x-4 border border-solid border-[#CFCFCF] p-[16px]">
          <div className="h-[44px] w-[44px] rounded-md bg-[#003460] p-[8px]">
            <img className="h-full w-full object-contain" src={tnva} />
          </div>
          <div className="flex flex-1 flex-col">
            <p className="text-sm">Total No. of Vehicles Affected</p>
            <p className="text-[24px] font-bold">{vehiclesAffectedData}</p>
          </div>
          {/* <button className="h-[32px] w-[32px] cursor-pointer bg-transparent">
            <img src={infoIcon} className="h-full w-full object-contain" />
          </button> */}
        </div>
      </div>
      <div className="flex-1 space-y-2">
        <div className="flex items-center space-x-4 border border-solid border-[#CFCFCF] p-[16px]">
          <div className="h-[44px] w-[44px] rounded-md bg-[#003460] p-[8px]">
            <img className="h-full w-full object-contain" src={iraRecieved} />
          </div>
          <div className="flex flex-1 flex-col">
            <p className="text-sm">Total Number of Affected Citizens</p>
            <p className="text-[24px] font-bold">{totalRecordsData}</p>
          </div>
          {/* <button className="h-[32px] w-[32px] cursor-pointer bg-transparent">
            <img src={infoIcon} className="h-full w-full object-contain" />
          </button> */}
        </div>
        <div className="flex items-center space-x-4 border border-solid border-[#CFCFCF] p-[16px]">
          <div className="h-[44px] w-[44px] rounded-md bg-[#003460] p-[8px]">
            <img className="h-full w-full object-contain" src={nrt} />
          </div>
          <div className="flex flex-1 flex-col">
            <p className="text-sm">Needs Reliable Transportation</p>
            <p className="text-[24px] font-bold">{transportationCountData}</p>
          </div>
          {/* <button className="h-[32px] w-[32px] cursor-pointer bg-transparent">
            <img src={infoIcon} className="h-full w-full object-contain" />
          </button> */}
        </div>
      </div>
      <div className="flex-1 space-y-2">
        <div className="flex items-center space-x-4 border border-solid border-[#CFCFCF] p-[16px]">
          <div className="h-[44px] w-[44px] rounded-md bg-[#003460] p-[8px]">
            <img className="h-full w-full object-contain" src={cww} />
          </div>
          <div className="flex flex-1 flex-col">
            <p className="text-sm">Citizens with Well Water</p>
            <p className="text-[24px] font-bold">{wellWaterCountData}</p>
          </div>
          {/* <button className="h-[32px] w-[32px] cursor-pointer bg-transparent">
            <img src={infoIcon} className="h-full w-full object-contain" />
          </button> */}
        </div>
      </div>
      <HouseholdsAffectedModal
        isOpen={showHouseholdsModal}
        onClose={() => setShowHouseholdsModal(false)}
        affectedHouseholds={affectedHouseholds}
      />
    </div>
  );
};

const Graphs = ({
  disasterImpactCount,
  injuryCount,
  homeDamageCount,
  homesDestroyedCount,
  displacedCount,
  ownerRenterCount,
  currentLivingSituationCount,
  typesOfHousingCount,
  mobilityMedicalNeedsCount,
  shelterDuringTornadoCount,
  typeOfPropertyDamageCount,
  immediateNeedsCount,
  waterDepthCount,
  insuranceTypeCount,
}) => {
  const onParsedDataGraph = (data) => {
    return Object.entries(data).map(([key, value]) => ({
      x: key,
      y: value,
      text: value,
    }));
  };

  // console.log({
  //   disasterImpactCount: onParsedDataGraph(disasterImpactCount),
  //   injuryCount: onParsedDataGraph(injuryCount),
  //   homeDamageCount: onParsedDataGraph(homeDamageCount),
  //   homesDestroyedCount: onParsedDataGraph(homesDestroyedCount),
  //   displacedCount: onParsedDataGraph(displacedCount),
  //   ownerRenterCount: onParsedDataGraph(ownerRenterCount),
  //   currentLivingSituationCount: onParsedDataGraph(currentLivingSituationCount),
  //   typesOfHousingCount: onParsedDataGraph(typesOfHousingCount),
  //   mobilityMedicalNeedsCount: onParsedDataGraph(mobilityMedicalNeedsCount),
  //   shelterDuringTornadoCount: onParsedDataGraph(shelterDuringTornadoCount),
  //   typeOfHomeDamageCount: onParsedDataGraph(typeOfHomeDamageCount),
  //   immediateNeedsCount: onParsedDataGraph(immediateNeedsCount),
  //   waterDepthCount: onParsedDataGraph(waterDepthCount),
  //   insuranceTypeCount: onParsedDataGraph(insuranceTypeCount)
  // });

  return (
    <div className="mt-2">
      <div className="space-y-2"></div>
      <div className="mt-2 grid grid-cols-2 gap-2">
        <PieChart
          title="Disaster"
          data={onParsedDataGraph(disasterImpactCount)}
          palettes={["#FF0000", "#04DF04", "#E5E5E5", "#E4DFDA"]}
          legend={["Affected", "Not Affected", "Not Applicable", "No Answer"]}
        />

        <BarChart
          title="Injury"
          data={onParsedDataGraph(injuryCount)}
          palettes={[
            "#FFF3CC",
            "#FFDB66",
            "#FFC300",
            "#997500",
            "#604900",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legends={[
            "No Injury",
            "Minor Injury",
            "Medical Treatment",
            "Visited Hospital",
            "Admitted",
            "Not Applicable",
            "No Answer",
          ]}
        />
        <PieChart
          title="Home Damaged"
          data={onParsedDataGraph(homeDamageCount)}
          palettes={[
            "#04DF04",
            "#0000FF",
            "#FFFF00",
            "#FFC300",
            "#FF0000",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legend={[
            "No Damage",
            "Slight Damage",
            "Moderate Damage",
            "Severe Damage",
            "Total Destruction",
            "Not Applicable",
            "No Answer",
          ]}
        />
        {/* <PieChart
          title="Home Destroyed"
          data={onParsedDataGraph(homesDestroyedCount)}
          palettes={["#00DF5C", "#F8C10C", "#EA3819", "#E4DFDA"]}
          legend={["Undamaged", "Damaged", "Destroyed", "No Answer"]}
        /> */}
        <PieChart
          title="Renters vs Owners"
          data={onParsedDataGraph(ownerRenterCount)}
          palettes={["#FFFF00", "#0000FF", "#04DF04", "#E4DFDA"]}
          legend={["Renter", "Homeowner", "Rent to Own", "No Answer"]}
        />
        <PieChart
          title="Is & Is not Displaced"
          data={onParsedDataGraph(displacedCount)}
          palettes={["#FF0000", "#04DF04"]}
          legend={["Is Displaced", "Isn't Displaced"]}
        />
        <PieChart
          title="Current Living Situation"
          data={onParsedDataGraph(currentLivingSituationCount)}
          palettes={[
            "#04DF04",
            "#FFC300",
            "#0000FF",
            "#FFFF00",
            "#FF0000",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legend={[
            "I am safely living inside my home",
            "I am unsafely living inside my home",
            "I am displaced with at the residence of a relative or friend",
            "I am displaced at a hotel or other form of temporary housing or shelter",
            "I am unsheltered",
            "Not Applicable",
            "No Answer",
          ]}
        />
        <PieChart
          title="Types of Housing"
          data={onParsedDataGraph(typesOfHousingCount)}
          palettes={[
            "#04DF04",
            "#0000FF",
            "#FFFF00",
            "#B9B9B9",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legend={[
            "Single Family Dwelling",
            "Mobile or Manufactured",
            "Condo",
            "Other",
            "Not Applicable",
            "No Answer",
          ]}
        />
        <PieChart
          title="Citizens Needing Mobility or Medical Equipment That Require Electricity"
          data={onParsedDataGraph(mobilityMedicalNeedsCount)}
          palettes={["#04DF04", "#FFC300", "#FF0000", "#E5E5E5", "#E4DFDA"]}
          legend={[
            "Yes, and I currently have electricity",
            "Yes, and I currently do not have electricity",
            "No",
            "Not Applicable",
            "No Answer",
          ]}
        />
        <PieChart
          title="Citizens Who Took Shelter during the Tornado"
          data={onParsedDataGraph(shelterDuringTornadoCount)}
          palettes={[
            "#04DF04",
            "#FFFF00",
            "#FFC300",
            "#0000FF",
            "#DE4BFB",
            "#FF0000",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legend={[
            "Yes, in my home",
            "Yes, in my storm shelter",
            "Yes, in my basement",
            "Yes, at a friend or family members",
            "Yes, in a public storm shelter",
            "No, I did not take shelter",
            "Not Applicable",
            "No Answer",
          ]}
        />

        <PieChart
          title="Additional Insurance"
          data={onParsedDataGraph(insuranceTypeCount)}
          palettes={["#04DF04", "#FFC300", "#0000FF", "#FF0000", "#E4DFDA"]}
          legend={[
            "Flood insurance",
            "Earthquake additional coverage",
            "Other disaster-related additional coverage",
            "I did not have additional insurance",
            "No Answer",
          ]}
        />
      </div>

      <div className="mt-2 space-y-2">
        <BarChart
          title="Type of Home Damage"
          data={onParsedDataGraph(typeOfPropertyDamageCount)}
          palettes={[
            "#FFEAEA",
            "#FFCCCC",
            "#FFAAAA",
            "#FF8888",
            "#FF6666",
            "#FF4444",
            "#E61010",
            "#FF0000",
            "#DD0000",
            "#B20202",
            "#8E0000",
            "#660909",
            "#4D0000",
            "#270000",
            "#2C3E50",
            "#C0392B",
            "#1F5D45",
            "#D2B48C",
            "#B9B9B9",
            "#E5E5E5",
          ]}
          legends={[
            "Sliding",
            "Flooring",
            "Cabinets",
            "Shed",
            "Ceiling",
            "Foundation",
            "Roof",
            "Floor Joists",
            "Gutters",
            "Electrical",
            "HVAC",
            "Driveway",
            "Drywall",
            "Yard/Uprooted Trees",
            "Basement",
            "Attached Garage",
            "Detached Garage",
            "Carport",
            "Other",
            "Not Applicable",
          ]}
        />
        <BarChart
          title="Immediate Needs"
          data={onParsedDataGraph(immediateNeedsCount)}
          palettes={[
            "#FFA500",
            "#0000FF",
            "#FF0000",
            "#28A745",
            "#FFC107",
            "#A27900",
            "#800080",
            "#FF637B",
            "#0084FF",
            "#5B5BFF",
            "#4CAF50",
            "#008080",
            "#01C8FF",
            "#6CD305",
            "#FF5733",
            "#4B8F29",
            "#D32F2F",
            "#169AF9",
            "#2C6B2F",
            "#FFEA36",
            "#B9B9B9",
            "#E5E5E5",
          ]}
          legends={[
            "Food / Nutrition",
            "Employment/Job Training",
            "Utilities (Shut-off or Pending Shut-off)",
            "Medical Health Care",
            "Transportation",
            "Furniture, Appliances",
            "Medication",
            "Child Care",
            "Clothing",
            "Counseling",
            "Financial Assistance",
            "Resource Information",
            "Personal Hygiene",
            "Medical Equipment",
            "Volunteer Support (Labor/Debris)",
            "Home Repair",
            "Eviction",
            "Water",
            "Mold Remediation",
            "Temporary Housing",
            "Other",
            "Not Applicable",
          ]}
        />
        <BarChart
          title="Depth of Water in Homes"
          subTitle="(Inches)"
          data={onParsedDataGraph(waterDepthCount)}
          palettes={[
            "#DBDBFF",
            "#9292FF",
            "#4949FF",
            "#0000FF",
            "#0000B6",
            "#040483",
            "#000056",
            "#E5E5E5",
            "#E4DFDA",
          ]}
          legends={[
            "No Water entered the home",
            "Less than 1 inch",
            "1 to 6 inches",
            "7 to 17 inches",
            "18 to 24 inches",
            "More than 24 inches",
            "Water reached ceiling or higher floor(s)",
            "Not Applicable",
            "No Answer",
          ]}
        />
      </div>
    </div>
  );
};

const Dashboard = ({ propId }) => {
  // const [disasterData, setDisasterData] = useState(null);
  const disasterId = Array.isArray(propId) ? propId[0] : propId;
  // const [affectedCounties, setAffectedCounties] = useState([]);
  const [selectedCounties, setSelectedCounties] = useState([]);
  // const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [checkboxStates, setCheckboxStates] = useState({
    show_disaster_impact_graph: false,
    show_injury_graph: false,
    show_home_damage_graph: false,
    show_homes_destroyed_graph: false,
    show_home_damage_typed_graph: false,
  });
  const [
    {
      disasterImpactCount,
      injuryCount,
      homeDamageCount,
      homesDestroyedCount,
      currentLivingSituationCount,
      typesOfHousingCount,
      typeOfPropertyDamageCount,
      immediateNeedsCount,
      mobilityMedicalNeedsCount,
      shelterDuringTornadoCount,
      waterDepthCount,
      householdMembersCount,
      totalRecords,
      vehiclesAffected,
      transportationCount,
      wellWaterCount,
      totalHouseholdAffected,
      displacedCount,
      ownerRenterCount,
      affectedHouseholds,
      insuranceTypeCount,
    },
    setGraphData,
  ] = useState({
    disasterImpactCount: {},
    injuryCount: {},
    homeDamageCount: {},
    homesDestroyedCount: {},
    currentLivingSituationCount: {},
    typesOfHousingCount: {},
    typeOfPropertyDamageCount: {},
    immediateNeedsCount: {},
    mobilityMedicalNeedsCount: {},
    shelterDuringTornadoCount: {},
    waterDepthCount: {},
    householdMembersCount: {},
    totalRecords: {},
    vehiclesAffected: {},
    transportationCount: {},
    wellWaterCount: {},
    totalHouseholdAffected: {},
    displacedCount: {},
    ownerRenterCount: {},
    affectedHouseholds: {},
    insuranceTypeCount: {},
  });

  const selectedUserId = sessionStorage.getItem("userId");

  useEffect(() => {
    const fetchUserRole = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user && selectedUserId) {
        const userDoc = await getDoc(doc(db, "users", selectedUserId));
        if (userDoc.exists()) {
          const role = userDoc.data().user_role;
          // setUserRole(role);
        }
      }
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
    const fetchDisaster = async () => {
      if (!disasterId) {
        console.error("No valid ID provided.");
        return;
      }

      try {
        const docRef = doc(db, "declared-disaster", disasterId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          // setDisasterData(data);

          // Format the affected counties
          const formattedCounties = Array.isArray(data.affected_counties)
            ? data.affected_counties.map((county) => ({
                text: county,
                value: county,
              }))
            : [];

          // setAffectedCounties(formattedCounties);

          // Set selectedCounties based on fetched data
          setSelectedCounties(formattedCounties.map((county) => county.value));
        } else {
          // setAffectedCounties([]);
          setSelectedCounties([]);
        }
      } catch (error) {
        // setAffectedCounties([]);
        setSelectedCounties([]);
      }
    };

    fetchDisaster();
  }, [disasterId]);

  useEffect(() => {
    const loadSurveyData = async (counties) => {
      try {
        const graphData = await DisasterMgtService.fetchDisasterSurvey(
          disasterId,
          counties
        );

        setGraphData(graphData);
      } catch (error) {
        console.error("Error loading survey data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedCounties.length > 0) {
      loadSurveyData(selectedCounties);
    }
  }, [selectedCounties]);

  useEffect(() => {
    const fetchUserCheckboxStates = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user && selectedUserId) {
        setUserId(selectedUserId);
        const userDocRef = doc(db, "users", selectedUserId);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCheckboxStates({
            ...checkboxStates,
            ...userData,
          });
        }
      }
    };

    fetchUserCheckboxStates();
  }, []);

  useEffect(() => {
    const fetchDisasterNames = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(db, "declared-disaster")
        );
        const names = querySnapshot.docs.map((doc) => doc.data().disaster_name);
      } catch (error) {
        console.error("Error fetching disaster names:", error);
      }
    };

    fetchDisasterNames();
  }, []);

  const handleCountyChange = (event) => {
    try {
      if (event && event.value !== undefined) {
        const selectedValues = Array.isArray(event.value) ? event.value : [];
        setSelectedCounties(selectedValues);

        // Rerun data fetching functions based on the new selected counties
        // loadSurveyData(selectedValues);
      } else {
        setSelectedCounties([]);
      }
    } catch (error) {
      console.error("Error in handleCountyChange:", error);
      setSelectedCounties([]);
    }
  };

  const handleCheckboxChange = async (field, checked) => {
    setCheckboxStates((prev) => ({
      ...prev,
      [field]: checked,
    }));

    if (userId) {
      const userDocRef = doc(db, "users", userId);
      await updateDoc(userDocRef, {
        [field]: checked,
      });
    }
  };

  return (
    <div className="flex h-full min-h-[94vh] flex-col py-3 pr-3">
      <HeaderTitle title="Dashboard" />
      {!loading && (
        <>
          <KPI
            totalHouseholdAffected={totalHouseholdAffected}
            totalRecords={totalRecords}
            vehiclesAffected={vehiclesAffected}
            transportationCount={transportationCount}
            wellWaterCount={wellWaterCount}
            householdMembersCount={householdMembersCount}
            affectedHouseholds={affectedHouseholds}
          />
          <Graphs
            disasterImpactCount={disasterImpactCount}
            injuryCount={injuryCount}
            homeDamageCount={homeDamageCount}
            homesDestroyedCount={homesDestroyedCount}
            displacedCount={displacedCount}
            ownerRenterCount={ownerRenterCount}
            currentLivingSituationCount={currentLivingSituationCount}
            typesOfHousingCount={typesOfHousingCount}
            mobilityMedicalNeedsCount={mobilityMedicalNeedsCount}
            shelterDuringTornadoCount={shelterDuringTornadoCount}
            typeOfPropertyDamageCount={typeOfPropertyDamageCount}
            immediateNeedsCount={immediateNeedsCount}
            waterDepthCount={waterDepthCount}
            totalHouseholdAffected={totalHouseholdAffected}
            totalRecords={totalRecords}
            vehiclesAffected={vehiclesAffected}
            transportationCount={transportationCount}
            wellWaterCount={wellWaterCount}
            insuranceTypeCount={insuranceTypeCount}
          />
        </>
      )}
    </div>
  );
};

export default Dashboard;
